export const SessionStorageKey = {
    SURVEY_LANGUAGE_OVERRIDE: 'surveyLanguageOverride',
} as const;
